/* This example requires Tailwind CSS v2.0+ */
import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {selectUser} from "../../features/user/userSlice";
import {createItem, getList} from "../../services/service";
import SelectImgComponent from "../SelectImgComponent";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import ToggleWithLabel from "../ToggleWithLabel";

export default function ModalConnectionType({open, setOpen, item, id, fetchData}) {
    const cancelButtonRef = useRef(null);
    const navigate = useNavigate();
    const [productList, setProductList] = useState([]);
    const [selectedImg, setSelectedImg] = useState("");
    const [selectedIconId, setSelectedIconId] = useState(null);
    const [isDefault, setIsDefault] = useState(false);
    const {token} = useSelector(selectUser);
    const handleChangeItem = (value) => {
        setSelectedIconId(value.id);
        setSelectedImg(value);
    };
    const {t} = useTranslation();
    const fetchList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/type/enum/connection/type`,
            token
        );
        if (response.success) {
            let adaptionData = response.data.map((item) => {
                return {
                    id: item.id,
                    name: (
                        <img
                            className=" w-12 h-12 rounded-full "
                            src={`${process.env.REACT_APP_HOST_BASE_URL}/v1/file/connection/${item.id}`}
                            alt={"img"}
                        />
                    ),
                };
            });
            setProductList(adaptionData);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        fetchList();
    }, [open]);

    const handleSave = async (event) => {
        event.preventDefault();
        const response = await createItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/type`,
            token,
            {
                connectionId: id,
                name: event.target.name.value.trim(),
                priority: event.target.priority.value.trim(),
                connectionTypeIndex: selectedIconId,
                isDefault: isDefault,
            }
        );
        if (response.success) {
            setSelectedIconId(null);
            setSelectedImg("");
            setIsDefault(false);
            fetchData();
            setOpen(false);
            toast.success(t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setOpen}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl  sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                                <form onSubmit={handleSave}>
                                    <div className="mt-3 sm:mt-2">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {t('connection_type')}
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <div className="mt-5 sm:mt-6">
                                                <div className="mt-3">
                                                    <label
                                                        htmlFor="name"
                                                        className="block text-sm font-medium text-gray-700"
                                                    >
                                                        {t('name')}
                                                    </label>
                                                    <div className="relative flex items-center mt-1 mb-2">
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            className="block w-full  border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <label
                                                        htmlFor="priority"
                                                        className="block text-sm font-medium text-gray-700"
                                                    >
                                                        {t('priority')}
                                                    </label>
                                                    <div className="relative flex items-center mt-1 mb-2">
                                                        <input
                                                            type="number"
                                                            name="priority"
                                                            id="priority"
                                                            className="block w-full  border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <SelectImgComponent
                                                        data={productList}
                                                        title={"Type"}
                                                        item={selectedImg}
                                                        onchange={handleChangeItem}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <ToggleWithLabel
                                                        label={t('default')}
                                                        enabled={isDefault}
                                                        setEnabled={setIsDefault}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="mt-8 sm:mt-10 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                        <button
                                            type="submit"
                                            className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                                        >
                                            {t('save')}
                                        </button>
                                        <button
                                            type="button"
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                                            onClick={() => {
                                                setOpen(false);
                                                setSelectedImg(null);
                                                setIsDefault(false);
                                            }}
                                            ref={cancelButtonRef}
                                        >
                                            {t('cancel')}
                                        </button>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
